<svg style="background:var(--anatomy-gray-100); width: calc(100% - 20px); padding: 10px; max-height: 205px;" height="151" viewBox="0 0 156 151">
  <defs>
    <filter id="Background" x="0" y="35" width="156" height="116" filterUnits="userSpaceOnUse">
      <feOffset dy="1" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="2" result="blur"/>
      <feFlood flood-opacity="0.149"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Menu" transform="translate(-1607 -420)">
    <g id="Action_button" data-name="Action button" transform="translate(1613 420)">
      <rect id="Placement_Area" data-name="Placement Area" width="32" height="32" fill="red" opacity="0"/>
      <g id="Background-2" data-name="Background" fill="var(--anatomy-gray-200)" stroke="var(--anatomy-gray-500)" stroke-width="1">
        <rect width="32" height="32" rx="4" stroke="none"/>
        <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="none"/>
      </g>
      <g id="Icon">
        <rect id="Canvas" width="18" height="18" transform="translate(7 7)" fill="var(--anatomy-gray-900)" opacity="0"/>
        <circle id="Ellipse_12" data-name="Ellipse 12" cx="1.7" cy="1.7" r="1.7" transform="translate(14.2 14.4)" fill="var(--anatomy-gray-900)"/>
        <circle id="Ellipse_13" data-name="Ellipse 13" cx="1.7" cy="1.7" r="1.7" transform="translate(20.05 14.4)" fill="var(--anatomy-gray-900)"/>
        <circle id="Ellipse_14" data-name="Ellipse 14" cx="1.7" cy="1.7" r="1.7" transform="translate(8.35 14.4)" fill="var(--anatomy-gray-900)"/>
      </g>
    </g>
    <g id="Picker_menu" data-name="Picker menu" transform="translate(1613 460)">
      <rect id="Placement_Area-2" data-name="Placement Area" width="144" height="100" fill="red" opacity="0"/>
      <g transform="matrix(1, 0, 0, 1, -6, -40)" filter="url(#Background)">
        <g id="Background-3" data-name="Background" transform="translate(6 40)" fill="var(--anatomy-gray-50)" stroke="var(--anatomy-gray-400)" stroke-width="1">
          <rect width="144" height="104" rx="4" stroke="none"/>
          <rect x="0.5" y="0.5" width="143" height="103" rx="3.5" fill="none"/>
        </g>
      </g>
      <rect id="Hover" width="142" height="32" transform="translate(1 4)" fill="var(--anatomy-gray-900)" fill-opacity="0.04"/>
      <rect id="Menu_Item" data-name="Menu Item" width="57" height="32" transform="translate(12 4)" fill="var(--anatomy-gray-800)" fill-opacity="0"/>
      <text id="Edit_" data-name="Edit…" transform="translate(12 24)" fill="var(--anatomy-gray-800)" font-size="14" font-family="var(--anatomy-font)"><tspan x="0" y="0">Edit…</tspan></text>
      <rect id="Menu_Item-2" data-name="Menu Item" width="82" height="32" transform="translate(12 36)" fill="var(--anatomy-gray-800)" fill-opacity="0"/>
      <text id="Rename_" data-name="Rename…" transform="translate(12 56)" fill="var(--anatomy-gray-800)" font-size="14" font-family="var(--anatomy-font)"><tspan x="0" y="0">Rename…</tspan></text>
      <rect id="Menu_Item-3" data-name="Menu Item" width="72" height="32" transform="translate(12 68)" fill="var(--anatomy-gray-800)" fill-opacity="0"/>
      <text id="Delete_" data-name="Delete…" transform="translate(12 88)" fill="var(--anatomy-gray-800)" font-size="14" font-family="var(--anatomy-font)"><tspan x="0" y="0">Delete…</tspan></text>
    </g>
  </g>
</svg>
